import React from 'react'
import PropTypes from 'prop-types'
import TableSort from './TableSort'
import TableFilter from './TableFilter'

const TableHeader = ({ filter, filterSetting, orderBy, columnList, toggleSort, toggleMultiSort, changeFilter, hiddenColumns }) => {
    return (
        <thead>
            <TableSort
                orderBy={orderBy}
                toggleSort={toggleSort}
                toggleMultiSort={toggleMultiSort}
                columnList={columnList}
                hiddenColumns={hiddenColumns}
            />
            <TableFilter
                filter={filter}
                filterSetting={filterSetting}
                changeFilter={changeFilter}
                columnList={columnList}
                hiddenColumns={hiddenColumns}
            />
        </thead>
    )
}

TableHeader.propTypes = {
    columnList: PropTypes.array.isRequired,
    toggleSort: PropTypes.func.isRequired,
    toggleMultiSort: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    orderBy: PropTypes.object.isRequired,
    filterSetting: PropTypes.object,
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/modules/table/component/TableHeader.js